module.exports = __webpack_public_path__ + "img/team-bjoern-heinzelmann@2x.289300b8.jpg";